// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"23":"health-service","87":"tongue-diagnosis","150":"pulse-diagnosis","652":"health-assessment","738":"psychological-age","962":"home"}[chunkId] + "." + {"23":"dbd3898a","87":"6e2cce6b","150":"8be436ac","652":"f32108b2","738":"73f73cd8","962":"0d7e8a9d"}[chunkId] + ".css";
};